/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sreality_Attr_Share_DenominatorInputs */

const cs_sreality_attr_share_denominator = /** @type {(inputs: Sreality_Attr_Share_DenominatorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podíl — jmenovatel`)
};

const en_sreality_attr_share_denominator = /** @type {(inputs: Sreality_Attr_Share_DenominatorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share — denominator`)
};

/**
* | output |
* | --- |
* | "Share — denominator" |
*
* @param {Sreality_Attr_Share_DenominatorInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sreality_attr_share_denominator = /** @type {((inputs?: Sreality_Attr_Share_DenominatorInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sreality_Attr_Share_DenominatorInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sreality_attr_share_denominator(inputs)
	return cs_sreality_attr_share_denominator(inputs)
});